// Keeps the ChatGPT Ads pixel's user data in step with the signed-in user.
//
// app.blade.php inits the pixel once, on the full page load. Logging in or
// registering is an Inertia visit, not a reload, so without this the rest of
// that visit — the registration_completed event included — would still go out
// as the anonymous visitor the page was first loaded for. OpenAI's docs: when
// user data becomes available after login, call init again with the full user.
//
// The identity comes from the `openaiAds` shared prop (HandleInertiaRequests):
// hashed email and user id only, null for guests.

// undefined until the first page has been seen; '' while signed out.
let lastIdentity;

export function syncOpenAiPixelUser(props) {
    if (typeof window === 'undefined' || typeof window.oaiq !== 'function') {
        return;
    }

    const ads = props?.openaiAds;
    const user = ads?.user || null;
    const identity = user ? (user.external_id_sha256 || user.email_sha256 || '') : '';

    // The first page was initialised by the blade head with this same object.
    if (lastIdentity === undefined) {
        lastIdentity = identity;
        return;
    }

    if (identity === lastIdentity) {
        return;
    }

    lastIdentity = identity;

    // Signing out needs no call: there is nothing to add, and the next full
    // page load starts the pixel anonymous again.
    if (user && ads.pixelId) {
        window.oaiq('init', { pixelId: ads.pixelId, user });
    }
}
